import React from 'react';
import App from '@/pages/App'
// @ts-ignore
import RouterGuard from '@/components/RouterGuard'
import type { Route } from '@/types/common'
import guildRoutes from './guild'

// const Demo = React.lazy(() => import('@/pages/Guild/demo'))
const Recharge = React.lazy(() => import('@/pages/Recharge'))
const AgentLogin = React.lazy(() => import('@/pages/Agent/login'))
const AgentCoin = React.lazy(() => import('@/pages/Agent/coin'))
const AgentTransferRrecord = React.lazy(() => import('@/pages/Agent/transferRrecord'))
const PayResult = React.lazy(() => import('@/pages/Pay/result'))
const PayNotice = React.lazy(() => import('@/pages/Pay/notice'))
const Demo = React.lazy(() => import('@/pages/demo'))
const Login = React.lazy(() => import('@/pages/Login'))
const MyDiamond = React.lazy(() => import('@/pages/MyDiamond'))
const WithdrawAccount = React.lazy(() => import('@/pages/Withdraw/account'))
const AddWithdrawAccount = React.lazy(() => import('@/pages/Withdraw/addMethod'))
const Withdraw = React.lazy(() => import('@/pages/Withdraw'))
const WithdrawOrder = React.lazy(() => import('@/pages/Withdraw/order'))
const ConsoleCom = React.lazy(() => import('@/pages/Console'))
const AppRecharge = React.lazy(() => import('@/pages/AppRecharge'))
const RechargeFaq = React.lazy(() => import('@/pages/AppRecharge/faq'))
// 家族
const FamilySetAdmin = React.lazy(() => import('@/pages/Family/setAdmin'))
const FamilyAddAdmin = React.lazy(() => import('@/pages/Family/addAdmin'))
const FamilyLevel = React.lazy(() => import('@/pages/Family/level'))
const FamilyLevelDesc = React.lazy(() => import('@/pages/Family/levelDesc'))

export interface RoutesMap {
  [key: string]: string
}

const routes: Route[] = [
  {
    path: '/',
    name: 'App',
    title: 'Hoby',
    element: (<App />),
  },
  {
    path: '/login',
    name: 'Login',
    title: '登录',
    meta: {
      noAuthLogin: 0, // 不需要登录
    },
    element: (<Login />),
  },
  {
    path: '/agent/login',
    name: 'AgentLogin',
    title: '代理登录',
    meta: {
      noAuthLogin: 0, // 不需要登录
    },
    element: (<AgentLogin />),
  },
  ...guildRoutes,
  {
    path: '/recharge',
    name: 'Recharge',
    title: '充值',
    meta: {
      noAuthLogin: 0, // 不需要登录
    },
    element: (<Recharge />),
  },
  {
    path: '/agent/coin',
    name: 'AgentCoin',
    title: '代理商-金币',
    meta: {},
    element: (<RouterGuard><AgentCoin /></RouterGuard>),
  },
  {
    path: '/agent/transferRrecord',
    name: 'AgentTransferRrecord',
    title: '代理商-转账记录',
    meta: {},
    element: (<RouterGuard><AgentTransferRrecord /></RouterGuard>),
  },
  {
    path: '/pay/result',
    name: 'PayResult',
    title: '支付结果',
    meta: {
      noAuthLogin: 0, // 不需要登录
    },
    element: (<PayResult />),
  },
  {
    path: '/pay/notice',
    name: 'PayNotice',
    title: '支付通知',
    meta: {
      noAuthLogin: 0, // 不需要登录
    },
    element: (<PayNotice />),
  },
  {
    path: '/demo',
    name: 'Demo',
    title: 'Demo',
    meta: {
      noAuthLogin: 0, // 不需要登录
    },
    element: (<Demo />),
  },
  {
    path: '/my-diamond',
    name: 'MyDiamond',
    title: '我的钻石',
    element: (<MyDiamond />),
  },
  {
    path: '/withdraw/account',
    name: 'WithdrawAccount',
    title: '提现账户管理',
    element: (<WithdrawAccount />),
  },
  {
    path: '/withdraw/add-method',
    name: 'AddWithdrawAccount',
    title: '添加提现方式',
    element: (<AddWithdrawAccount />),
  },
  {
    path: '/withdraw',
    name: 'Withdraw',
    title: '提现',
    element: (<Withdraw />),
  },
  {
    path: '/withdraw/order',
    name: 'WithdrawOrder',
    title: '提现订单',
    meta: {
      janmi: 1
    },
    element: (<WithdrawOrder />),
  },
  {
    path: '/console',
    name: 'Console',
    title: '控制台',
    element: (<ConsoleCom />),
  },
  {
    path: '/app-recharge',
    name: 'appRecharge',
    title: 'app内充值',
    meta: {
      // noAuthLogin: 0, // 不需要登录
    },
    element: (<AppRecharge />),
  },
  {
    path: '/app-recharge/faq',
    name: 'RechargeFaq',
    title: 'app内充值常见问题',
    element: (<RechargeFaq />),
  },
  {
    path: '/family/set-admin',
    name: 'FamilySetAdmin',
    title: '家族设置管理员',
    element: (<FamilySetAdmin />),
  },
  {
    path: '/family/add-admin',
    name: 'FamilyAddAdmin',
    title: '家族添加管理员',
    element: (<FamilyAddAdmin />),
  },
  {
    path: '/family/level',
    name: 'FamilyLevel',
    title: '家族等级',
    element: (<FamilyLevel />),
  },
  {
    path: '/family/level-desc',
    name: 'FamilyLevelDesc',
    title: '家族等级说明',
    element: (<FamilyLevelDesc />),
  }
]

// 用来做路由导航时路径名和路径的映射
export const routesMap: RoutesMap = routes.reduce(
  (acc: RoutesMap, cur: Route) => {
    const { path, name } = cur
    acc[name] = path
    return acc
  },
  {},
)

export default routes
